import { CommonModule } from '@angular/common';
import { ScatterPlotModule } from '../scatter-plot/scatter-plot.module';
import { DateRangeModule } from 'Angular/features/components/date-controls/date-range/date-range.module';
import { FullYearDateRangeModule } from 'Angular/features/components/date-controls/full-year-date-range/full-year-date-range.module';
import { SingleDatePickerModule } from 'Angular/features/components/date-controls/single-date-picker/single-date-picker.module';
import { SimpleDropdownModule } from 'Angular/features/components/dropdowns/simple-dropdown/simple-dropdown.module';
import { SingleSelectDropdownModule } from 'Angular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { ColorPickerModule } from 'Angular/features/components/inputs/color-picker/color-picker.module';
import { RadioButtonGroupModule } from 'Angular/features/components/inputs/radio-button-group/radio-button-group.module';
import { SkeletonLoadersListModule } from 'Angular/features/components/loaders/skeleton-loaders-list/skeleton-loaders.module';
import { HelpModalModule } from 'Angular/features/components/modals/help-modal/help-modal.module';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { LegacyAssetConversionCheckerModule } from 'ConverterApp/features/legacy-asset-conversion-checker/legacy-asset-conversion-checker.module';
import { FoldersSharedModule } from 'FoldersApp/features/folders-shared/app.module';
import { AddButtonAutocompleteModule } from 'SearchApp/ts/features/add-button-autocomplete/add-button-autocomplete.module';
import { AutocompleteInPlaceModule } from 'SearchApp/ts/features/autocomplete-in-place/autocomplete-in-place.module';
import { MultiItemAutocompleteModule } from 'SearchApp/ts/features/multi-item-autocomplete/multi-item-autocomplete.module';
import { SecurityListSelectorModalModule } from 'SecurityListsApp/ts/features/security-list-selector-modals/security-list-selector-modal.module';
import { GetOwnerDisplayNamePipeModule } from 'SharingApp/ts/pipes/get-owner-display-name.module';
import * as i0 from "@angular/core";
export class ScatterPlotPageSharedModule {
}
ScatterPlotPageSharedModule.ɵfac = function ScatterPlotPageSharedModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ScatterPlotPageSharedModule)(); };
ScatterPlotPageSharedModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ScatterPlotPageSharedModule });
ScatterPlotPageSharedModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AddButtonAutocompleteModule,
        AutocompleteInPlaceModule,
        ColorPickerModule,
        CommonModule,
        DateRangeModule,
        FullYearDateRangeModule,
        HelpModalModule,
        IconModule,
        LegacyAssetConversionCheckerModule,
        ModalBaseModule,
        MultiItemAutocompleteModule,
        RadioButtonGroupModule,
        ScatterPlotModule,
        SecurityListSelectorModalModule,
        SimpleDropdownModule,
        SingleDatePickerModule,
        SingleSelectDropdownModule,
        SkeletonLoadersListModule,
        TooltipModule,
        FoldersSharedModule,
        GetOwnerDisplayNamePipeModule,
        DisabledModule] });
